import {
  collection,
  getDocs,
  firestore,
  doc,
  updateDoc,
  getDoc,
  addDoc,
  query,
  deleteDoc,
  where,
} from "../utils/firebase";
import bcrypt from "bcryptjs";
export const updateData = async (path, data, id) => {
  const docRef = doc(firestore, path, id);
  await updateDoc(docRef, data);
};

export const getSingleData = async (path, id) => {
  const docRef = doc(firestore, path, id);
  const docSnapshot = await getDoc(docRef);

  if (docSnapshot.exists()) {
    return docSnapshot.data();
  } else {
    console.log("Document does not exist.");
  }
};

export const getData = async (path, queryy = null) => {
  const q = query(collection(firestore, path));
  if (queryy != null) {
    q = queryy;
  }
  const querySnapshot = await getDocs(q);

  const filteredDocuments = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return filteredDocuments;
};

export const doCalculations = async (path) => {
  const q = query(collection(firestore, "/work"));
  const querySnapshot = await getDocs(q);
  let processing = 0;
  let count = 0;
  let sum = 0;
  let cancelled = 0;
  let completed = 0;
  let pending = 0;
  let refunded = 0;

  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const value = data.price;
    if (data.status == "processing") {
      processing++;
    }
    if (data.status == "completed") {
      completed++;
    }
    if (data.status == "cancelled") {
      cancelled++;
    }
    if (data.status == "pending") {
      pending++;
    }
    if (data.status == "refunded") {
      refunded++;
    }
    sum += value;
    count++;
  });
  return {
    total: sum,
    count,
    processing,
    completed,
    pending,
    cancelled,
    refunded,
  };
};

export const usersCount = async () => {
  try {
    const q = query(collection(firestore, "/users"));
    const querySnapshot = await getDocs(q);
    let users = 0;
    let providers = 0;
    let providersOnline = 0;
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.isServiceProvider == true) {
        if (data.isLive) {
          providersOnline++;
        }
        providers++;
      } else {
        users++;
      }
    });
    return { users, providers, providersOnline };
  } catch (error) {
    console.log(error);
  }
};
export const createSuperAdminUser = async () => {
  try {
    const { email, password } = {
      email: "admin@admin.com",
      password: "admin123",
    };

    // Check if the "admins" collection exists
    const q = query(collection(firestore, "admins"));
    const querySnapshot = await getDocs(q);
    const hashedPassword = await bcrypt.hash(password, 10); // Hash the password

    if (querySnapshot.empty) {
      // The "admins" collection doesn't exist, so create it
      const adminsCollectionRef = collection(firestore, "admins");
      return _createAdmin(
        email,
        hashedPassword,
        "superadmin",
        adminsCollectionRef
      );
    } else {
      // The "admins" collection exists; check if there are no "admin" users
      const adminQuery = query(
        collection(firestore, "admins"),
        where("role", "==", "superadmin")
      );
      const adminQuerySnapshot = await getDocs(adminQuery);

      if (adminQuerySnapshot.empty) {
        // Create an admin user in the "admins" collection since no "admin" user exists
        return _createAdmin(
          email,
          hashedPassword,
          "superadmin",
          adminQuerySnapshot
        );
      }
    }
  } catch (error) {
    console.error("Error creating admin user: ", error);
  }
};

const _createAdmin = async (
  email,
  hashedPassword,
  role,
  adminQuerySnapshot
) => {
  const adminUserData = {
    email: email, // Set the admin user's email
    role: role ?? "admin", // Set the user type to "admin"
    password: hashedPassword, // Save the hashed password
  };
  return await addDoc(adminQuerySnapshot, adminUserData);
};

export const createAdminUser = async (body) => {
  try {
    const adminsCollectionRef = collection(firestore, "admins");
    const { email, password } = body;
    return _createAdmin(email, password, "admin", adminsCollectionRef);
  } catch (error) {
    console.error("Error creating admin user: ", error);
  }
};

export const handleLogin = async (email, password) => {
  try {
    // Authenticate the user with Firebase Authentication
    // Retrieve the hashed password for the given email from Firestore
    const adminsCollectionRef = collection(firestore, "admins");
    const q = query(adminsCollectionRef, where("email", "==", email));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      // Get the first document matching the query
      const docSnapshot = querySnapshot.docs[0];

      // Check if the provided password matches the hashed password from Firestore
      const storedHashedPassword = docSnapshot.data().password;

      if (await bcrypt.compare(password, storedHashedPassword)) {
        // Passwords match; successfully logged in as a "admin"
        const filteredDocuments = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        return filteredDocuments[0];
      } else {
        // Passwords do not match
        return null;
      }
    } else {
      // The user is not a "admin"
      return null;
    }
  } catch (error) {
    console.error("Error logging in: ", error);
  }
};

export const deleteData = async (id, path) => {
  const docRef = doc(firestore, path, id);
  await deleteDoc(docRef);
};
